import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CurrencyType } from 'src_common/common/amount/website-money/currency';
import { useCommon } from 'src/AppState/Common';
import { useAppStateContext } from 'src/AppState/AppState';
import { DateTime } from 'src_common/utils/time/time';
import Icon from 'src/components/Icon/Icon';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';

type FreeBetsActiveTableBonusEnginePropsType = {
    currency: CurrencyType;
    customerId: number;
    permisionsAllowed: boolean;
    handleShowModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const defaultDateFormat = 'DD/MM/YY';

export const FreeBetsActiveTableBonusEngine = observer(
    'FreeBetsActiveTableBonusEngine',
    ({ customerId, currency, permisionsAllowed, handleShowModal }: FreeBetsActiveTableBonusEnginePropsType) => {
        const common = useCommon();
        const { bankingTabState } = useAppStateContext();
        const state = bankingTabState.get(customerId);
        const { precision } = ConfigState.get(common);
        const freebetsHistory = state.freebetsListBonusEngine.get();
        const filteredHistory =
            freebetsHistory.type === 'ready'
                ? [...freebetsHistory.value].filter((item) => item.status === 'active')
                : [];

        return (
            <div className='freebets__credits'>
                <table
                    key='free-bets-credits'
                    className='freebets__credits'
                >
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Promotion / Source</th>
                            <th className='align-right'>Amount</th>
                            <th className='align-right'>Remove</th>
                        </tr>
                    </thead>
                    <tbody>
                        {freebetsHistory.type === 'ready'
                            ? filteredHistory.reverse().map((bonusItem, index) => {
                                  const expiryDate = bonusItem.expiryAt;

                                  const date = bonusItem.createdAt ?? undefined;
                                  const promotion =
                                      bonusItem.rewardName === null
                                          ? bonusItem.bonusSource
                                          : `${bonusItem.rewardName} - ${bonusItem.bonusSource}`;
                                  const amount = bonusItem.totalAmount;

                                  return (
                                      <tr key={`${bonusItem.bonusId}${expiryDate}${index}`}>
                                          <td data-test='current-free-bet-credits-date'>
                                              {DateTime.from(date)?.format(defaultDateFormat)}
                                          </td>
                                          <td data-test='current-free-bet-credits-promotion/source'>
                                              <span key='promotion-name'> {promotion}</span>
                                              <span
                                                  key='expiry-date'
                                                  className='small-text'
                                              >
                                                  Expires: {DateTime.from(expiryDate)?.format(defaultDateFormat)}
                                              </span>
                                          </td>
                                          <td
                                              className='align-right'
                                              data-test='free-bet-history-amount'
                                          >
                                              {amount !== undefined && amount !== null
                                                  ? precision.newFromOld(amount).format(currency)
                                                  : '-'}
                                          </td>
                                          <td
                                              className='align-center'
                                              data-test='current-free-bet-credits-remove-icon'
                                          >
                                              {permisionsAllowed === true ? (
                                                  <span
                                                      className='freebets__remove'
                                                      data-value={bonusItem.bonusId}
                                                      onClick={handleShowModal}
                                                      data-test='remove-icon'
                                                  >
                                                      <Icon name='trashcan' />
                                                  </span>
                                              ) : (
                                                  <span>Not Allowed</span>
                                              )}
                                          </td>
                                      </tr>
                                  );
                              })
                            : null}
                    </tbody>
                </table>
                {(freebetsHistory.type === 'ready' && filteredHistory.length === 0) ||
                freebetsHistory.type === 'error' ? (
                    <div className='freebets__info'>No free bet credits available</div>
                ) : null}
            </div>
        );
    }
);
